export class PeerMetrics {
  peerId: string;
  availableBandwidthKbps: number;
  latencyMs: number;
  relayLoad: number;
  hopCount: number;
  directlyConnected: boolean;
  cpuScore: number;
  participantCount: number;

  constructor(peerId: string) {
    this.peerId = peerId;
    this.availableBandwidthKbps = 2000;
    this.latencyMs = 0;
    this.relayLoad = 0;
    this.hopCount = 0;
    this.directlyConnected = false;
    this.cpuScore = 1.0;
    this.participantCount = 0;
  }

  get relayCapacity(): number {
    const overhead = this.relayLoad * 500;
    return Math.max(0, (this.availableBandwidthKbps - overhead) * this.cpuScore);
  }

  get suitabilityScore(): number {
    const latency = this.latencyMs || 0;
    const hops = this.hopCount || 0;
    const load = this.relayLoad || 0;
    const bandwidth = this.availableBandwidthKbps || 0;
    return latency + hops * 200 + load * 100 - bandwidth / 10;
  }
}
